/**
 * Màn hình danh sách tài khoản người dùng
 */
import { memo } from "react";
import { Layout, Typography, Space } from "antd";
import ListUser from "pages/User/ListUser";
const { Title } = Typography;
const { Content } = Layout;
function User() {
  return (
    <Content
      className="custom-layout-content background-content-layout"
      style={{
        marginLeft: 24,
        marginTop: 16,
        marginRight: 24,
        // backgroundColor: "white",
      }}
    >
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
        size={"large"}
      >
        <div className="space-between ">
          <Title style={{ marginBottom: 0 }} level={4}>
            Danh sách tài khoản
          </Title>
        </div>
        <ListUser />
      </Space>
    </Content>
  );
}

export default memo(User);
